export default "__VITE_ASSET__Crg8f2sd__"